import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=22bdb839&scoped=true&"
import script from "./AboutUs.vue?vue&type=script&lang=js&"
export * from "./AboutUs.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/aboutus.css?vue&type=style&index=0&id=22bdb839&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdb839",
  null
  
)

export default component.exports